"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.analyticsContext = exports.AnalyticsProvider = void 0;
var _react = require("react");
const analyticsContext = exports.analyticsContext = /*#__PURE__*/ (0, _react.createContext)({
    currentCourierName: {
        current: undefined
    },
    isAddingNewDelivery: {
        current: false
    },
    originalCourierName: {
        current: undefined
    },
    originalSelectedDeliveryItem: {
        current: undefined
    }
});
const AnalyticsProvider = exports.AnalyticsProvider = analyticsContext.Provider;
